<template>
  <div class="news-classify">
    <div class="cl-title">
      <el-image :src="require('@/assets/news/icon.png')"></el-image>
      <span>{{ name }}</span>
    </div>
    <div class="cl-title" :class="tClassifyId == v.classifyId?'act':''" v-for="(v,i) in classifyList"
         :key="i" @click="classifyFun(v)">
      <span>{{ v.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Classify",
  props: {
    name: String,
    classifyId: [String, Number],
    tClassifyId: [String, Number]
  },
  data() {
    return {
      classifyList: []
    }
  },
  watch: {
    '$route.query': {
      immediate: true,
      deep: true,
      handler({name, classifyId, tClassifyId}) {
        this.name = name
        this.classifyId = classifyId
        if (tClassifyId) {
          this.$emit('update:tClassifyId', tClassifyId)
        }
        this.$request.get('/Product/classifyList', {
          params: {
            parentId: classifyId
          }
        }).then(res => {
          if (res.code === 0) {
            this.classifyList = res.data
            if (res.data.length > 0 && !tClassifyId) {
              this.$emit('update:tClassifyId', res.data[0].classifyId)
            }
          }
        })
      }
    }
  },
  methods: {
    /**
     * 分类选择
     * @param classifyId
     */
    classifyFun({classifyId}) {
      if (this.$route.path == '/product/detail') {
        this.$router.push(`/product/classify?classifyId=${this.classifyId}&name=${this.name}&tClassifyId=${classifyId}`)
      } else {
        this.$emit('update:tClassifyId', classifyId)
      }
    }
  }
}
</script>

<style scoped lang="scss">
.news-classify {
  width: 240px;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
  background-color: #FFFFFF;
  border-radius: 8px;
  overflow: hidden;

  .cl-title {
    height: 55px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #D7D7D7;
    cursor: pointer;

    &.act span {
      color: #1464FF;
    }

    span {
      color: #2D2D2D;
      font-size: 16px;
      font-weight: bold;
    }

    &:first-child {
      background-color: #1464FF;
      cursor: unset;

      span {
        color: #FFFFFF;
      }

      .el-image {
        width: 24px;
        height: 24px;
        margin-right: 2px;
      }
    }

    &:last-child {
      border-bottom: 0;
    }
  }
}
</style>